import { Star } from 'lucide-react';

interface RatingStarsProps {
    totalStars?: number;
    filledStars?: number;
}

export const RatingStars = ({ totalStars = 5, filledStars = 5 }: RatingStarsProps) => {
    return (
        <div className="flex items-center gap-1 text-osYellow-1">
            {Array.from({ length: totalStars }).map((_, index) => (
                <Star key={index} size={24} fill={index < filledStars ? 'currentColor' : 'none'} />
            ))}
        </div>
    );
};